import { isStandaloneDisplay } from "../../pwa/platform";
import { usePushSubscription } from "../../pwa/usePushSubscription";

export default function PushToggle() {
  const { state, busy, error, enable, disable } = usePushSubscription();

  if (state === "loading" || state === "unsupported") return null;

  if (state === "blocked") {
    const standalone = isStandaloneDisplay(
      window.matchMedia("(display-mode: standalone)").matches,
      (navigator as Navigator & { standalone?: unknown }).standalone,
    );
    return (
      <div className="pwa-install-card" role="region" aria-label="Notificaciones push">
        <span className="pwa-install-card__text">
          {standalone
            ? "Las notificaciones están bloqueadas. En Android: mantén pulsado el ícono de la app, luego Información, luego Notificaciones. En iPhone: Ajustes, luego Notificaciones, luego Torneos123."
            : "Las notificaciones están bloqueadas por tu navegador. Para activarlas: toca el candado junto a la dirección, luego Permisos, luego Notificaciones, luego Permitir."}
        </span>
      </div>
    );
  }

  if (state === "ios-needs-install") {
    return (
      <div className="pwa-install-card" role="region" aria-label="Notificaciones push">
        <span className="pwa-install-card__text">
          Instala la app (Compartir → Agregar a pantalla de inicio) para recibir
          avisos en este iPhone.
        </span>
      </div>
    );
  }

  const on = state === "on";
  return (
    <div className="pwa-install-card" role="region" aria-label="Notificaciones push">
      <span className="pwa-install-card__text">
        Avisos en este dispositivo: <strong>{on ? "activados" : "desactivados"}</strong>
      </span>
      <button
        type="button"
        className={on ? "btn btn--secondary" : "btn btn--primary"}
        disabled={busy}
        onClick={() => void (on ? disable() : enable())}
      >
        {on ? "Desactivar" : "Activar"}
      </button>
      {error ? <span className="pwa-install-card__steps">{error}</span> : null}
    </div>
  );
}
